export enum InvoicesApisActionTypes {
    INVOICES_API_RESPONSE_SUCCESS = 'INVOICES_API_RESPONSE_SUCCESS',
    INVOICES_API_RESPONSE_ERROR = 'INVOICES_API_RESPONSE_ERROR',
    GET_INVOICES_APIS_DATA = 'GET_INVOICES_API_DATA'
}
